import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnrollCommissionDecision} from '../components/model/enroll-commission-decision';

@Injectable()
export class EnrollCommissionDecisionService {

  constructor(private http: HttpClient) {
  }

  checkForFreeGrantPlaces(decision: EnrollCommissionDecision) {
    return this.http.post<any>(`api/enrolls/enrollApplication/commissionDecision/checkForFreeGrantPlaces`, decision);
  }

  confirmDecision(enrollId: number, decision: EnrollCommissionDecision) {
    return this.http.post<any>(`api/enrolls/enrollApplication/commissionDecision/confirm/${enrollId}`, decision);
  }

  cancelDecision(enrollId: number, decision: EnrollCommissionDecision) {
    return this.http.post<any>(`api/enrolls/enrollApplication/commissionDecision/cancel/${enrollId}`, decision);
  }

  getConfirmedCommissionDecision(enrollId: number) {
    return this.http.get<any>(`api/enrolls/enrollApplication/commissionDecision/${enrollId}`);
  }

  rangingPastByQualification(educated: number, qualification: number) {
    return this.http.get<any>(`api/enrolls/enrollApplication/commissionDecision/rangingPast/${educated}/${qualification}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/services/enroll-commission-decision.service.ts